<template>
  <div style="width:100%;height:100%;margin:0 auto;">
    <el-button
        type="info"
        style="background-color: #008a2c"
        icon="el-icon-back"
        circle
        @click="router"
      ></el-button>
      <div
      style="
        width: 100%;
        text-align: center;
        font-size: 25px;
        font-weight: bold;
      "
    >
      大学生医保查询
    </div>
    <!-- <el-row :gutter="0" class="eltable">
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">姓名</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amusername}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">学号</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amuserid}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">院系</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amuserdepartname}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">专业</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amusermajor}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">班级</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amuserclass}}</div>
      </el-col>
      <el-col :span="2">
        <div class="eltableBackground bggray2 fb tc">联系方式</div>
      </el-col>
      <el-col :span="6">
        <div class="gridContent">{{userInfo.amusertel}}</div>
      </el-col>`
    </el-row> -->
        <div
        style="
            margin-top: 30px;
            justify-content: center;
            margin-left: 5%;
            margin-right: 5%;
          "
      >
        <el-row justify="center" align="middle" style>
          <el-col :span="2">
            <div class="trcol">预约人</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusername }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">学号/工号</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserid }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">院系/部门</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserdepartname }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="trcol">专业</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusermajor != null ? userInfo.amusermajor : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">班级</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserclass != null ? userInfo.amuserclass : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">手机号码</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusertel }}</div>
          </el-col>
        </el-row>
      </div>
  <div class="form">
    <el-table :data="insuranceInfo" border 
    :row-style="{height: '120px'}" :header-cell-style="{background:'#d8efbf',color:'#606266',height: '70px','text-align':'center'}" 
    :cell-style="{'text-align':'center'}" header-align="center" empty-text="未查询到您的医保信息" class="custom-table">
      <el-table-column prop="feeslifespan" label="年度" width="100"></el-table-column>
      <el-table-column prop="insuredunit" label="参保单位" width="180"></el-table-column>
      <el-table-column prop="insuredstatus" label="参保状态" width="150"></el-table-column>
      <el-table-column prop="paymentyear" label="缴费年度" width="130"></el-table-column>
      <el-table-column prop="paymentamount" label="缴费金额（元）" width="137"></el-table-column>
      <el-table-column prop="paymentstatus" label="缴费状态" width="150"></el-table-column>
      <el-table-column prop="insurance" label="保险类型" width="200"></el-table-column>
      <el-table-column prop="insuredaddress" label="参保所属地" width="200"></el-table-column>
      <el-table-column prop="feeslifespan" label="费款所属期" width="130"></el-table-column>
    </el-table>
  </div>
    <el-button
      type="success"
      class="button-wrapper"
      @click="router"
      style="margin-left: 50%;margin-top: 25px"
    >返回大厅首页</el-button>
  </div>
</template>

<script>
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import { queryInsuranceInfoByUserid } from "@/api/medicalInsurance.js";
import "@/static/css/my.css";
import { ipURL } from "@/config/net.config.js";
import { mapGetters } from "vuex";

export default {
  name: "serviceInfor",
  data() {
    return {
      isFollow: 0,
      activeName: "first",
      score: 3.7,
      infoData: [],
      ipURL: ipURL,
      showBtn: false, // 我要办事按钮是否可见,true 可见
      serviceId: "",
      url: "",
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      userInfo: {
        amuserid: "",
        amusername: "",
        amusertel: "",
        amuserdepartcode: "",
        amuserdepartname: "",
        amusermajor: "",
        amusergrade: "",
        amuserclass: ""
      },
      clearInsuranceInfo: {
        feeslifespan: "",
        insurance: "",
        insuredaddress: "",
        insuredstatus: "",
        insuredunit: "",
        paymentamount: "",
        paymentstatus: "",
        paymentyear: ""
      },
      insuranceInfo:[],
      insuranceInfo1: {},
      insuranceInfo2: {},
      insuranceInfo3: {},
      insuranceInfo4: {},
      title1: "暂无数据",
      title2: "暂无数据",
      title3: "暂无数据",
      title4: "暂无数据"
    };
  },
  computed: {
    ...mapGetters(["getUserId", "getUserInfo"])
  },
  async mounted() {
    let testuserInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    this.userInfo = {
      amuserid: testuserInfo.userid,
      amusername: testuserInfo.name,
      amusertel: testuserInfo.amusertel,
      amuserdepartcode: testuserInfo.amuserdepartcode,
      amuserdepartname: testuserInfo.department,
      amusermajor: testuserInfo.major,
      amuserclass: testuserInfo.bj
    };
    let data = await queryInsuranceInfoByUserid(this.userInfo.amuserid);
    this.insuranceInfo = data.data;
    this.insuranceInfo1 = this.clearInsuranceInfo;
    this.insuranceInfo2 = this.clearInsuranceInfo;
    this.insuranceInfo3 = this.clearInsuranceInfo;
    this.insuranceInfo4 = this.clearInsuranceInfo;
    if (data.data != null) {
      if (data.data[0] != undefined) {
        this.insuranceInfo1 = data.data[0];
        this.title1 = data.data[0].feeslifespan + "年度";
      }
      if (data.data[1] != undefined) {
        this.insuranceInfo2 = data.data[1];
        this.title2 = data.data[1].feeslifespan + "年度";
      }
      if (data.data[2] != undefined) {
        this.insuranceInfo3 = data.data[2];
        this.title3 = data.data[2].feeslifespan + "年度";
      }
      if (data.data[3] != undefined) {
        this.insuranceInfo4 = data.data[3];
        this.title4 = data.data[3].feeslifespan + "年度";
      }
    }
    console.log("list数据", data);
  },
  methods: {
    router() {
      this.$router.push("/");
    }
  }
};
</script>
<style scoped>
.trcol {
  background-color: #d8efbf;
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.tdcol {
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}
.form {
  margin-left: 5%;
  /* border:1px solid #dddddd; */
  margin-top: 30px;
  /* padding: 20px; */
  margin-right: 5%;
}
.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.eltable {
  /* border-left: 1px solid #dddddd; */
  margin-top: 20px;
  border-top: 1px solid #dddddd;
}

.eltable .gridContent {
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
  font-size: 14px;
}

.eltableBackground {
  background: rgba(155, 213, 91, 0.39);
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
  font-size: 14px;
}

.eltableBackgroundTop {
  background: #f8f8f8;
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
  font-size: 16px;
}

.el-rate__icon {
  font-size: 28px;
}

.button .button-wrapper,
.button_solid .button-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: inherit;
  align-items: inherit;
  margin-right: 20px;
}

/**我要收藏，取消收藏 按钮 样式 start */
.el-button.is-circle {
  border-radius: 50%;
  padding: 8px;
}

.isfollow {
  font-size: 20px;
  color: red;
}

.isfollow:hover {
  font-size: 20px;
  color: white;
}

.nofollow {
  font-size: 20px;
  color: white;
}

.nofollow:hover {
  font-size: 20px;
  color: red;
}

/**我要收藏，取消收藏 按钮 样式 end */

.other:hover {
  color: white;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
}

.custom-table .el-table__empty-text {
  font-size: 16px;
}
</style>